import { auth } from "@/lib/auth";

const API_BASE =
    (import.meta as any).env?.VITE_API_URL || "https://api.linguaproz.com";

export const PAYMENTS_UNAVAILABLE_MESSAGE =
    "Payments are temporarily unavailable. Please try again later.";

// POSTs to cat-payfast.js (translyx-api), then redirects the browser to
// PayFast by building and submitting a hidden form from the returned
// fields. Only call this from an explicit user action.
export async function startPayfastCheckout(
    endpoint: "subscribe" | "purchase-pack",
    body: Record<string, string>,
): Promise<void> {
    const session = await auth.getSession();
    if (!session?.access_token) {
        throw new Error("Please sign in again to continue.");
    }

    const res = await fetch(`${API_BASE}/api/cat/payfast/${endpoint}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify(body),
    });
    if (res.status === 503) {
        throw new Error(PAYMENTS_UNAVAILABLE_MESSAGE);
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.error || "Failed to start checkout.");
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.processUrl;
    Object.entries(data.fields).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
